import React, { memo } from 'react'
import { useTitleSection, TitleSectionProps } from './useTitleSection'
import styles from './TitleSection.module.scss'

const TitleSection: React.FC<TitleSectionProps> = (
  props: TitleSectionProps
) => {
  const { title, descriptionTitle, description } = useTitleSection(props)

  return (
    <div className={`${styles['title-section']} container`}>
      <span className='description-title'>{title}</span>
      <h2>{descriptionTitle}</h2>
      <p>{description}</p>
    </div>
  )
}

export default memo(TitleSection)
